import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";
import useIsOnlySpaceAdmin from "shared/Space/useIsOnlySpaceAdmin";
import { AccountContext } from "views/AccountWrapper";

import {
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS,
  MainNavigationPrimaryMenuItemKeys,
} from "./menuItemsPrimary";

const useSettingsMenuItems = () => {
  const { viewer } = useTypedContext(AccountContext);
  const isSpaceAdmin = useIsOnlySpaceAdmin();

  const accountSettingsMenuItem = useMemo(() => {
    return viewer.admin || isSpaceAdmin
      ? MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.AccountSettings]
      : undefined;
  }, [viewer.admin, isSpaceAdmin]);

  const accountUsersSettingsMenuItem = useMemo(() => {
    return viewer.admin
      ? MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.AccountUsersSettings]
      : undefined;
  }, [viewer.admin]);

  return {
    accountSettingsMenuItem,
    accountUsersSettingsMenuItem,
  };
};

export default useSettingsMenuItems;
